<a [routerLink]="url">
  <img [src]="imageUrl" />
  <div class="mt-4 mb-4 mb-sm-0 d-flex justify-content-center justify-content-sm-start" *ngIf="title">
    <h6>{{ title }}</h6>
    <fa-icon class="ms-2" [icon]="['far', 'chevron-right']"></fa-icon>
  </div>
</a>
